import { Icon } from '@lubehub/ui-web';
import { useEffect } from 'react';
import { Link } from 'react-router';

import { t } from '../copy';
import { usePublicLocale } from '../locale';

/**
 * An unknown public URL. The host rewrites every path to this app, so without
 * this screen `/random-path` would be a blank page.
 *
 * The status is still 200: Apache serves the same `index.html` for every path
 * and only the browser knows the route is unknown. A static host cannot send a
 * 404 for a client-side route without a server-side list of routes. So the
 * page tells search engines not to index it instead — this site is indexable,
 * and a soft 404 that says otherwise would be listed as a page.
 */
export function NotFoundPage() {
  const { locale } = usePublicLocale();

  useEffect(() => {
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex';
    document.head.appendChild(robots);

    return () => {
      robots.remove();
    };
  }, []);

  return (
    // Inside the shell's <main>, so not a second one.
    <div className="public-state" data-testid="not-found">
      <span className="lh-icon-tile lh-icon-tile--lg" aria-hidden="true">
        <Icon name="search" size={24} />
      </span>
      <h1 className="public-state__title">{t(locale, 'notFound.title')}</h1>
      <p className="public-state__body">{t(locale, 'notFound.body')}</p>
      <Link className="lh-button lh-button--primary" to="/" data-testid="not-found-home">
        <span className="lh-button__label">{t(locale, 'notFound.home')}</span>
      </Link>
    </div>
  );
}
